const ENDPOINT_LETTS_CHAT_DATA =
  "https://esurveyecommercebackend.emtelco.co/api/forms/data/1/";

const ENDPOINT_LETTS_CHAT_VIEW =
  "https://esurveyecommercebackend.emtelco.co/api/forms/view/1/";

window.addEventListener("DOMContentLoaded", () => {
  const getData = async () => {
    const selectCategory = document.getElementById("categoria");
    const selectProduct = document.getElementById("producto");

    // Deshabilita el select de productos inicialmente
    selectProduct.disabled = true;

    selectCategory.addEventListener("change", function () {
      var categoria = this.value;

      if (categoria) {

        // Habilita el select de productos si se selecciona una categoría
        selectProduct.disabled = false;

        var url = "/collections/" + categoria + "/products.json";

        // Realizar una solicitud AJAX para obtener los productos de la categoría seleccionada
        fetch(url)
          .then((response) => response.json())
          .then((data) => {
            // Limpiar las opciones actuales del selector de productos
            selectProduct.innerHTML = '<option value="">Seleccione un producto</option>';

            // Agregar las nuevas opciones basadas en los datos recibidos
            data.products.forEach(function (product) {
              var option = document.createElement("option");
              option.value = product.title; // Cambiar para almacenar el título del producto
              option.textContent = product.title;
              selectProduct.appendChild(option);
            });
          })
          .catch((error) => {
            console.error("Error fetching products:", error);
          });
      } else {
        // Si no se selecciona ninguna categoría, deshabilita el select de productos
        selectProduct.disabled = true;
        selectProduct.innerHTML = '<option value=""></option>'; // Limpia las opciones del select de productos
      }
    });
  };

  // Validacion

  const valite = (data) => {
    // Name
    if (
      data.nombres_y_apellidos.length > 0 &&
      data.nombres_y_apellidos.length < 5 ||
      data.nombres_y_apellidos.trim().split(" ").length < 2
    ) {
      // Obtén el modal por su id
      var modal = document.getElementById("popup-modal-error");

      // Muestra el modal
      modal.classList.remove("hidden");

      //Muestra el mensaje del modal

      document.getElementById("name_message").classList.remove("hidden");

      // Obtén el botón que cierra el modal
      var closeBtn = modal.getElementsByClassName("close")[0];

      // Obtén el botón "Aceptar" que cierra el modal
      var acceptBtn = document.getElementById("button-aceptt-modal");

      // Cuando el usuario hace clic en el botón de cerrar, cierra el modal
      closeBtn.onclick = function () {
        modal.classList.add("hidden");
      };

      // Cuando el usuario hace clic en el botón "Aceptar", cierra el modal
      acceptBtn.onclick = function () {
        modal.classList.add("hidden");
      };

      // Cuando el usuario hace clic fuera del modal, cierra el modal
      window.onclick = function (event) {
        if (event.target == modal) {
          modal.classList.add("hidden");
          // Opcional: también puedes ocultar todos los mensajes cuando se cierra el modal.
          document.querySelectorAll(".modal-message").forEach(msg => msg.classList.add("hidden"));
        }
      };

      return false;
    } else {
      document.getElementById("name_message").classList.add("hidden");
    }

    let regexCorreo = /\S+@\S+\.\S+/;

    if (!regexCorreo.test(data.correo_electronico)) {
      // Obtén el modal por su id
      var modal = document.getElementById("popup-modal-error");

      // Muestra el modal
      modal.classList.remove("hidden");

      //Muestra el mensaje del modal

      document.getElementById("email_message").classList.remove("hidden");

      // Obtén el botón que cierra el modal
      var closeBtn = modal.getElementsByClassName("close")[0];

      // Obtén el botón "Aceptar" que cierra el modal
      var acceptBtn = document.getElementById("button-aceptt-modal");

      // Cuando el usuario hace clic en el botón de cerrar, cierra el modal
      closeBtn.onclick = function () {
        modal.classList.add("hidden");
      };

      // Cuando el usuario hace clic en el botón "Aceptar", cierra el modal
      acceptBtn.onclick = function () {
        modal.classList.add("hidden");
      };

      // Cuando el usuario hace clic fuera del modal, cierra el modal
      window.onclick = function (event) {
        if (event.target == modal) {
          modal.classList.add("hidden");
          // Opcional: también puedes ocultar todos los mensajes cuando se cierra el modal.
          document.querySelectorAll(".modal-message").forEach(msg => msg.classList.add("hidden"));
        }
      };

      return false;
    } else {
      document.getElementById("email_message").classList.add("hidden");
    }

    // Celular
    if (data.celular.length < 10 || data.celular.length > 10) {
      // Obtén el modal por su id
      var modal = document.getElementById("popup-modal-error");

      // Muestra el modal
      modal.classList.remove("hidden");

      //Muestra el mensaje del modal

      document.getElementById("celular_message").classList.remove("hidden");

      // Obtén el botón que cierra el modal
      var closeBtn = modal.getElementsByClassName("close")[0];

      // Obtén el botón "Aceptar" que cierra el modal
      var acceptBtn = document.getElementById("button-aceptt-modal");

      // Cuando el usuario hace clic en el botón de cerrar, cierra el modal
      closeBtn.onclick = function () {
        modal.classList.add("hidden");
      };

      // Cuando el usuario hace clic en el botón "Aceptar", cierra el modal
      acceptBtn.onclick = function () {
        modal.classList.add("hidden");
      };

      // Cuando el usuario hace clic fuera del modal, cierra el modal
      window.onclick = function (event) {
        if (event.target == modal) {
          modal.classList.add("hidden");
          // Opcional: también puedes ocultar todos los mensajes cuando se cierra el modal.
          document.querySelectorAll(".modal-message").forEach(msg => msg.classList.add("hidden"));
        }
      };

      return false;
    } else {
      document.getElementById("celular_message").classList.add("hidden");
    }

    //Categoria

    if (data.categoria === "") {
      // Obtén el modal por su id
      var modal = document.getElementById("popup-modal-error");

      // Muestra el modal
      modal.classList.remove("hidden");

      //Muestra el mensaje del modal

      document.getElementById("category_message").classList.remove("hidden");

      // Obtén el botón que cierra el modal
      var closeBtn = modal.getElementsByClassName("close")[0];

      // Obtén el botón "Aceptar" que cierra el modal
      var acceptBtn = document.getElementById("button-aceptt-modal");

      // Cuando el usuario hace clic en el botón de cerrar, cierra el modal
      closeBtn.onclick = function () {
        modal.classList.add("hidden");
      };

      // Cuando el usuario hace clic en el botón "Aceptar", cierra el modal
      acceptBtn.onclick = function () {
        modal.classList.add("hidden");
      };

      // Cuando el usuario hace clic fuera del modal, cierra el modal
      window.onclick = function (event) {
        if (event.target == modal) {
          modal.classList.add("hidden");
          // Opcional: también puedes ocultar todos los mensajes cuando se cierra el modal.
          document.querySelectorAll(".modal-message").forEach(msg => msg.classList.add("hidden"));
        }
      };

      return false;
    } else {
      document.getElementById("category_message").classList.add("hidden");
    }

    //Producto

    if (data.producto === "") {
      // Obtén el modal por su id
      var modal = document.getElementById("popup-modal-error");

      // Muestra el modal
      modal.classList.remove("hidden");

      //Muestra el mensaje del modal

      document
        .getElementById("product_category_message")
        .classList.remove("hidden");

      // Obtén el botón que cierra el modal
      var closeBtn = modal.getElementsByClassName("close")[0];

      // Obtén el botón "Aceptar" que cierra el modal
      var acceptBtn = document.getElementById("button-aceptt-modal");

      // Cuando el usuario hace clic en el botón de cerrar, cierra el modal
      closeBtn.onclick = function () {
        modal.classList.add("hidden");
      };

      // Cuando el usuario hace clic en el botón "Aceptar", cierra el modal
      acceptBtn.onclick = function () {
        modal.classList.add("hidden");
      };

      // Cuando el usuario hace clic fuera del modal, cierra el modal
      window.onclick = function (event) {
        if (event.target == modal) {
          modal.classList.add("hidden");
          // Opcional: también puedes ocultar todos los mensajes cuando se cierra el modal.
          document.querySelectorAll(".modal-message").forEach(msg => msg.classList.add("hidden"));
        }
      };

      return false;
    } else {
      document
        .getElementById("product_category_message")
        .classList.add("hidden");
    }

    if (data.atdp === false) {
      // Obtén el modal por su id
      var modal = document.getElementById("popup-modal-consulta");

      // Muestra el modal
      modal.classList.remove("hidden");

      // Obtén el botón que cierra el modal
      var closeBtn = modal.getElementsByClassName("close")[0];

      // Cuando el usuario hace clic en <span> (x), cierra el modal
      closeBtn.onclick = function () {
        modal.classList.add("hidden");
      };

      // Cuando el usuario hace clic fuera del modal, cierra el modal
      window.onclick = function (event) {
        if (event.target == modal) {
          modal.classList.add("hidden");
          // Opcional: también puedes ocultar todos los mensajes cuando se cierra el modal.
          document.querySelectorAll(".modal-message").forEach(msg => msg.classList.add("hidden"));
        }
      };

      return false;
    }

    return true;
  };

  const getDataForm = () => {
    return {
      nombres_y_apellidos: formChat.querySelector("#nombres_y_apellidos").value,
      correo_electronico: formChat.querySelector("#correo_electronico").value,
      celular: formChat.querySelector("#celular").value,
      categoria: formChat.querySelector("#categoria").value,
      producto: formChat.querySelector("#producto").value, // Cambiado para obtener el título del producto
      atdp: formChat.querySelector("#atdp").checked,
    };
  };

  const addInput = (form, name, value) => {
    let input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  };

  getData();

  let formChat = document.querySelector("#form-contact-chat");
  if (formChat) {
    formChat.addEventListener("submit", function (e) {
      e.preventDefault();
      const data = getDataForm();

      if (!valite(data)) {
        return;
      }

      const payload = {
        valuesJSON: {
          nombres_y_apellidos: data.nombres_y_apellidos,
          correo_electronico: data.correo_electronico,
          celular: data.celular,
          categoria: data.categoria,
          producto: data.producto, // Ahora se guarda el nombre del producto
          atdp: data.atdp,
        },
      };

      //Modal para la validacion de datos

      // Obtener el modal
      var modal = document.getElementById("popup-modal-compra");

      // Obtener el botón que cierra el modal
      var closeButton = modal.getElementsByClassName("close")[0];

      // Función para mostrar el modal
      function showModal() {
        modal.classList.remove("hidden");
      }

      // Función para ocultar el modal
      function hideModal() {
        modal.classList.add("hidden");
        location.reload(); // Recargar la página después de cerrar el modal
      }

      // Evento para cerrar el modal cuando se hace clic en el botón de cerrar
      closeButton.addEventListener("click", hideModal);

      // Evento para cerrar el modal cuando se hace clic fuera del contenido del modal
      window.addEventListener("click", function (event) {
        if (event.target == modal) {
          hideModal();
        }
      });

      // Reemplazar el alert con showModal en tu .then
      // Asumiendo que tienes el fragmento de código en algún lugar de tu archivo .liquid

      fetch(ENDPOINT_LETTS_CHAT_DATA, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      })
        .then((Response) => Response.json())
        .then((dataResponse) => {
          console.log("Success:", dataResponse);
          console.log("payload:", payload);
          showModal();
        })
        .catch((Error) => {
          console.error("Error", Error);
        })
        .finally(() => {
          // boton.disable = false; // Habilitar el botón en caso de error de red
        });
    });
  }
});
